import React from "react";

const QuestionForm = ({ question, editQuestion }) => {
  const updateQuestion = (e) => editQuestion(e.target.name, e.target.value);
  return (
    <div className="mb-5">
      <label>
        <small>Question</small>
      </label>
      <textarea
        type="text"
        className="form-control form-control-sm mb-2"
        name="text"
        value={question.text}
        onChange={updateQuestion}
      />
      <label>
        <small>Options</small>
      </label>
      <div className="row g-2 mb-2">
        <div className="col-12 col-md-6">
          <div className="input-group input-group-sm">
            <span className="input-group-text">A</span>
            <input
              type="text"
              name="a"
              className="form-control"
              value={question.a}
              onChange={updateQuestion}
            />
          </div>
        </div>
        <div className="col-12 col-md-6">
          <div className="input-group input-group-sm">
            <span className="input-group-text">B</span>
            <input
              type="text"
              name="b"
              className="form-control"
              value={question.b}
              onChange={updateQuestion}
            />
          </div>
        </div>
        <div className="col-12 col-md-6">
          <div className="input-group input-group-sm">
            <span className="input-group-text">C</span>
            <input
              type="text"
              name="c"
              className="form-control"
              value={question.c}
              onChange={updateQuestion}
            />
          </div>
        </div>
        <div className="col-12 col-md-6">
          <div className="input-group input-group-sm">
            <span className="input-group-text">D</span>
            <input
              type="text"
              name="d"
              className="form-control"
              value={question.d}
              onChange={updateQuestion}
            />
          </div>
        </div>
      </div>
      <label>
        <small>Answer</small>
      </label>
      <select
        className="form-select form-select-sm"
        name="answer"
        value={question.answer}
        onChange={updateQuestion}
      >
        <option value="a">A</option>
        <option value="b">B</option>
        <option value="c">C</option>
        <option value="d">D</option>
      </select>
    </div>
  );
};

export default QuestionForm;
